export const formatChange = (change: number) => {
  return Number(change.toFixed(2)).toLocaleString()
}
